const data = {
    categoryTitle: 'Explore Categories',
    categorySubTitle: 'Professional by categories',
    viewAll: 'View All',
    freelancerTitle: 'Top Freelancers',
    freelancerSubTitle: 'Start With Great Peoples',
    freelancerDescription: 'Lorem ipsum dolor amet consectetur adipisicing eliteiuim sete eiusmod tempor incididunt ut labore etnalom dolore magna aliqua udiminimate veniam quis norud.'
};

export default data;